import PlatformSection from './platform-section';

export default PlatformSection;
